import { EmptyState, GroupDot, ListSkeleton, Panel } from "@mixitone/components/Controls";
import RacketIcon from "@mixitone/icons/racket.svg";
import { ApplicationView } from "@mixitone/mvc";
import { ClubDetailsPageController } from "controllers/ClubDetailsPageController";

export const GameHistory = ApplicationView(() => {
  const controller = ClubDetailsPageController.use();
  const { games, loadingGames } = controller.state;

  return (
    <Panel title="Game history" titleClassName="font-semibold" className="overflow-hidden">
      {loadingGames && <ListSkeleton itemCount={6} />}
      {games.length === 0 && !loadingGames && <EmptyState Icon={RacketIcon}>No games yet</EmptyState>}
      {games.length > 0 && !loadingGames && (
        <div className="flex flex-col gap-6">
          {games.map((session) => (
            <section key={session.date} className="min-w-0">
              <h3 className="mb-1 text-sm font-semibold text-slate-900">{session.date}</h3>
              <ul className="divide-y divide-slate-100">
                {session.games.map((game) => (
                  <li key={`${session.date}-${game.index}`} className="flex items-start gap-3 py-3">
                    <span className="w-12 shrink-0 text-sm tabular-nums text-slate-500">
                      Set {game.index + 1}
                    </span>
                    <div className="flex min-w-0 flex-1 flex-wrap gap-x-4 gap-y-1.5">
                      {game.players.map((player, playerIdx) => (
                        <div key={playerIdx} className="flex max-w-full items-center gap-2">
                          <GroupDot group={player.group} size={14} className="flex-shrink-0" />
                          <span className="text-sm text-slate-900">{player.name}</span>
                        </div>
                      ))}
                    </div>
                  </li>
                ))}
              </ul>
            </section>
          ))}
        </div>
      )}
    </Panel>
  );
});
